import { Link, useNavigate, useParams } from "react-router-dom";
import { getN, navigationData } from "./navigationData/NavigationData";
import { useEffect, useState } from "react";
import { MdDashboard } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { CgLogOut } from "react-icons/cg";
import { useTranslation } from "react-i18next";
import { Button, Spinner } from "react-bootstrap";
import { removeItemFromLocalStorage } from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setIsLogin } from "../../slice/auth";
import { getLength, getMenusdata } from "../../api/login/Login";
import asidemainmodicon from "../../assets/icons/aside-icon/admin.svg"
import { baseUrlImage } from "../../baseUrl";
let asideMenu = [];
function Aside({ showAsideBar }) {
  const [parentId, setParentId] = useState(null);
  const [childId, setChildId] = useState(null);
  const [countLaenData, setCountLenData] = useState(null);
  const [mainMenus, setMainMenus] = useState([]);
  const [isMenusLoaded, setIsMenusLoaded] = useState(false);

  // const [tokenUpdated, setTokenUpdated] = useState();
  // const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  console.log(location, "location");

  const menuClicked = (parentId) => {
    setParentId((prev) => (prev === parentId ? null : parentId));
    setChildId(null);
  };
  const subMenuClicked = (e, childId) => {
    setChildId((prev) => (prev === childId ? null : childId));
    e.stopPropagation();
  };

  const handleLogOut = () => {
    removeItemFromLocalStorage("userToken");
    dispatch(setIsLogin({ isLogin: false }));
  };

  // useEffect(() => {
  //   const modifiedPath = location.pathname.replace("/admin/", "");
  //   asideMenu.forEach((item) => {
  //     item?.subMenus.map((submenu) => {
  //       if (submenu.path === modifiedPath) {
  //         setChildId(submenu.uniqueId);
  //         setParentId(item.uniqueId);
  //       }
  //     });
  //   });
  // }, []);
  const getCountData = async () => {
    try {
      const response = await getLength()
      setCountLenData(response?.data)
    } catch (error) {
      if (error?.response?.status === 401 || error?.message?.includes("401")) return;
      alert(error.message)
    }
  }


  asideMenu = navigationData(countLaenData)

  //  ------------------Navigation Data Apis------------

  const getMensAllData = async () => {
    try {
      const menusRes = await getMenusdata();
      let menus = menusRes?.data || [];
      if (Array.isArray(menus)) {
        menus = menus.map((m) => {
          if (m?.title?.toLowerCase() === "reports") {
            const hasReversal = m?.subMenus?.some(
              (sub) => sub?.path?.includes("reversal-fund-report")
            );
            if (!hasReversal) {
              const updatedSub = [...(m.subMenus || [])];
              updatedSub.push({
                uniqueId: "reversal_fund_report_menu",
                id: "reversal_fund_report_menu",
                title: "Reversal Fund Report",
                path: "reversal-fund-report",
              });
              updatedSub.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
              return { ...m, subMenus: updatedSub };
            }
          }
          return m;
        });
      }
      // Fallback: If Kyc Details is not returned by the backend, inject it right below Members
      const hasKycMenu = menus.some((m) => m?.title?.toLowerCase() === "kyc details");
      if (!hasKycMenu) {
        const membersIdx = menus.findIndex((m) => m?.title?.toLowerCase() === "members");
        const fallbackKyc = {
          uniqueId: 9999998,
          id: 999998,
          title: "Kyc Details",
          subMenus: [
            {
              uniqueId: 999981,
              id: 999981,
              title: "Verified",
              path: "kyc-details/verified",
            },
            {
              uniqueId: 999982,
              id: 999982,
              title: "Not Verified",
              path: "kyc-details/not-verified",
            },
          ],
        };
        if (membersIdx !== -1) {
          menus.splice(membersIdx + 1, 0, fallbackKyc);
        } else {
          menus.push(fallbackKyc);
        }
      }
      setMainMenus(menus);
    } catch (error) {
      console.error(error);
    } finally {
      setIsMenusLoaded(true);
    }
  };


  useEffect(() => {
   
    getCountData()
    const modifiedPath = location.pathname.replace("/admin/", "");

    const allMenus = [...(asideMenu || []), ...(mainMenus || [])];
    const foundSubMenu = allMenus
      .flatMap((item) => item?.subMenus || [])
      .find((submenu) => submenu?.path === modifiedPath);

    if (foundSubMenu) {
      setChildId(foundSubMenu.uniqueId);
      const parentItem = allMenus.find((item) =>
        item.subMenus?.some((sub) => sub.uniqueId === foundSubMenu.uniqueId)
      );
      if (parentItem) {
        setParentId(parentItem.uniqueId);
      }
    }
  }, []);
  // useEffect(() => {
  //   getMensAllData()
  //   setTokenUpdated(location.state)
  // }, [childId,tokenUpdated])

  useEffect(() => {
    getMensAllData()
  }, [])
  return (
    <>
      <div
        className={`deznav ${!showAsideBar ? "showMenu" : "hideMenu"}`}
        id="abcd"
      >
        <div className="deznav-scroll mm-active d-flex flex-column justify-content-between ">
          <ul className="metismenu mm-show flex-1" id="menu">
            <li className={`mm-active hideDarrow  ${!showAsideBar ? "hide" : ""}`}>
              <Link className="" to={"/admin"} aria-expanded="false">
                <span className="menu-icon">
                  <MdDashboard />
                </span>
                <span className={`nav-text`}> {t("Dashboard")} </span>
              </Link>
            </li>
            {Array.isArray(mainMenus) && mainMenus.length > 0 ? (
  mainMenus.map((item, i) => (
    <li
      className={`mm-active ${!showAsideBar ? "hide" : ""} ${parentId === item.uniqueId ? "active" : ""}`}
      onClick={() => menuClicked(item.uniqueId)}
      key={i}
    >
      <Link className="has-arrow" aria-expanded="false">
        <div className="">
          <div className="menu-icon">
           
              {/* {item?.module_img ? <img src={baseUrlImage + item?.module_img} width={'18px'} />  : */}
               <span>{"⍟"}
                 </span>
              {/* }  */}
          
          </div>
          <span className={`nav-text`}> {t(item?.title)}</span>
        </div>
      </Link>
      <ul
        aria-expanded="false"
        className={`mm-collapse left ${item.uniqueId === parentId ? "mm-show" : ""}`}
      >
        {item?.subMenus?.map((subItem, i) => (
          <li
            className={`mm-active sidebar-content ${childId === subItem.uniqueId ? "active" : ""}`}
            onClick={(e) => subMenuClicked(e, subItem.uniqueId)}
          >
            <Link to={subItem?.path} className="mm-active">
              {t(subItem?.title)}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  ))
) : !isMenusLoaded ? (
  <span className={`nav-text`} style={{ padding: "0.825rem 1.875rem" }}>
    <Spinner animation="grow" size="sm" className="me-2" />
    <small>Loading ...... </small>
  </span>
) : (
  <span className={`nav-text`} style={{ padding: "0.825rem 1.875rem", color: "#888" }}>
    <small>No modules assigned</small>
  </span>
)}

          </ul>
          <div className="help-desk ">
            {/* <Link to="#" className="btn btn-primary">Help Desk</Link>
                            &nbsp; */}
            {/* <Button
              className="btn btn-warning"
              type="button"
              onClick={handleLogOut}
            >
              <CgLogOut /> <span>Log out </span>
            </Button> */}
          </div>
        </div>
      </div>
    </>
  );
}
export default Aside;
